import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  Typography,
  Grid,
  Container,
  Alert,
  AlertTitle,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  Stepper,
  Step,
  StepLabel,
  Divider,
  CircularProgress
} from "@mui/material";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import axios from "axios";
import { tokens } from "../../../../../theme";
import { useTheme } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from '@mui/icons-material/Check';
import otpImage from "../../../../../components/varification_img.avif";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SendIcon from "@mui/icons-material/Send";
import { useAuth } from "../../../components/AuthContext";
import ClearIcon from '@mui/icons-material/Clear';
const steps = ["Professional Overview", "Profile & Preferences"];


const ShortlistForm = () => {
  const { id } = useParams();
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpVerified, setOtpVerified] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(true);
  const [isFormAlreadySubmitted, setIsFormAlreadySubmitted] = useState(false);
  const [jobData, setJobData] = useState(null);
  const [openVideoModal, setOpenVideoModal] = React.useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isVerySmallScreen = useMediaQuery("(max-width:580px)");
  const isTabletOrBelow = useMediaQuery("(max-width:900px)");
  const { setOtpVerification, setEmail } = useAuth();
  const [website, setWebsite] = useState("");
  const [progress, setProgress] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [isResendingOtp, setIsResendingOtp] = useState(false);
  const [sendOtpProgress, setSendOtpProgress] = useState(0);
  const [verifyOtpProgress, setVerifyOtpProgress] = useState(0);
  const [resendOtpProgress, setResendOtpProgress] = useState(0);
  const [dialogProgress, setDialogProgress] = useState(0);
  // const isError = dialogTitle === "Error";
  const [showCheckmark, setShowCheckmark] = useState(false);
  const [progressDialogStage, setProgressDialogStage] = useState("submitting"); 
  const [showIcon, setShowIcon] = useState(false);
  const initialFormState = {
    Do_you_want_to_work_with_a_small_org: "",
    Describe_yourself: "",
    Roles_and_responsibilities: "",
    Why_apply: "",
    Five_year_goal: "",
    Preferred_Location: "",
    current_ctc: "",
    Current_Take_Home_Monthly: "",
    expected_ctc: "",
    Expected_CTC_Negotiable: "",
    Total_Experience: "",
    Relevant_Experience: "",
    Earliest_Joining_days: "",
    Holding_other_offer: "N",
  };

  const requiredFields = [
    "Describe_yourself",
    "Five_year_goal",
    "Preferred_Location",
    "current_ctc",
    "Total_Experience",
  ];

  const fieldsPerStep = {
    0: ["Describe_yourself"],
    1: [
      "Five_year_goal",
      "Preferred_Location",
      "current_ctc",
      "Total_Experience",
    ],
  };
  const [formData, setFormData] = useState(initialFormState);
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  useEffect(() => {
  }, [id]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // accept only digits
    const updatedOtp = [...otp];

    if (value.length === 1) {
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Move to next box if exists
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }

    // Handle paste of multiple digits
    if (value.length > 1) {
      for (let i = 0; i < value.length && index + i < otp.length; i++) {
        updatedOtp[index + i] = value[i];
      }
      setOtp(updatedOtp);

      const nextInput = document.querySelector(
        `input[name=otp-${index + value.length}]`
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];

      if (otp[index]) {
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
        const prevInput = document.querySelector(
          `input[name=otp-${index - 1}]`
        );
        if (prevInput) prevInput.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      const prevInput = document.querySelector(`input[name=otp-${index - 1}]`);
      if (prevInput) prevInput.focus();
    }

    if (e.key === "ArrowRight" && index < otp.length - 1) {
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-config`);
        const data = await res.json();
        if (res.ok) {
          setEmail(data.email || "");
          setWebsite(data.website || "");
        }
      } catch (err) {
        console.error("Error fetching config:", err);
      }
    };
    fetchConfig();
    let sendInterval, verifyInterval, resendInterval, submitInterval;
  
    if (isSendingOtp) {
      sendInterval = setInterval(() => {
        setSendOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (isVerifyingOtp) {
      verifyInterval = setInterval(() => {
        setVerifyOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (isResendingOtp) {
      resendInterval = setInterval(() => {
        setResendOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (dialogOpen && progressDialogStage === "submitting") {
      submitInterval = setInterval(() => {
        setDialogProgress((prevProgress) => {
          if (prevProgress >= 90) return 90; // Keep at 90% until server responds
          return prevProgress + 10;
        });
      }, 200);
    } else if (dialogOpen && (progressDialogStage === "success" || progressDialogStage === "error")) {
      setDialogProgress(100);
      setTimeout(() => setShowIcon(true), 300);
    }
  
    return () => {
      clearInterval(sendInterval);
      clearInterval(verifyInterval);
      clearInterval(resendInterval);
      clearInterval(submitInterval);
    };
  }, [isSendingOtp, isVerifyingOtp, isResendingOtp, dialogOpen, progressDialogStage]);

  useEffect(() => {
    if (dialogOpen) {
      // Reset states when dialog opens
      setDialogProgress(0);
      setShowCheckmark(false);

      // Start progress animation
      const timer = setInterval(() => {
        setDialogProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(timer);
            // Show checkmark after a small delay
            setTimeout(() => setShowCheckmark(true), 200);
            return 100;
          }
          return prevProgress + 2; // Increase by 2% every 50ms (will complete in 2.5 seconds)
        });
      }, 50);

      return () => clearInterval(timer);
    }
  }, [dialogOpen]);

  useEffect(() => {
    if (!id) {
      console.log("No id provided");
      return;
    }
    const fetchJobApplication = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/job_application/form/${id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const formDetails = response.data;
        setJobData(response.data);

        if (formDetails.form_submitted === true) {
          setFormData(formDetails);
          setIsFormAlreadySubmitted(true);
          setOtpVerified(false);
          setShowOtpScreen(false);
          setSubmitted(true);
        }
      } catch (error) {
        console.error("Error fetching job application:", error);
      }
    };

    fetchJobApplication();
  }, [id, formData?.form_submitted]);

  const getOtp = () => otp.join("");

  const handleVerifyOtp = async () => {
    setIsVerifyingOtp(true);
    setVerifyOtpProgress(25);
    try {
      const otpValue = getOtp();
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/verify-otp`,
        {
          otp: otpValue,
          id,
        }
      );

      if (res.data.status === "verified") {
        setOtpVerification(true);
        setOtpVerified(true);
        setShowOtpScreen(false);
        setError("");
        setSubmitted(res.data.submitted || false);
        setFormData(res.data.formData);
        setVerifyOtpProgress(100);
      } else {
        setError("Invalid OTP");
        setVerifyOtpProgress(0);
      }
    } catch (err) {
      console.error(err);
      setError("OTP verification failed");
      setVerifyOtpProgress(0);
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  useEffect(() => {
    if (id && !otpVerified && !submitted) {
      setShowOtpScreen(true);
    }
  }, [id, otpVerified, submitted]);

  const handleSendOtp = async () => {
    setIsSendingOtp(true);
    setSendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);
    console.log("Start OTP send");
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: id, status: "Shortlisted" }),
      });

      const data = await response.json();
      if (response.ok) {
        setIsOtpSent(true);
        setError("");
        setSendOtpProgress(100);
      } else {
        setError(data.message || "Failed to send OTP. Please try again.");
        setSendOtpProgress(0);
      }
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
      setSendOtpProgress(0);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    setIsResendingOtp(true);
    setResendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`,
        {
          id,
          is_resend: true,
          status: "Shortlisted"
        }
      );

      if (response.status === 200) {
        setIsOtpSent(true);
        setOtp(["", "", "", "", "", ""]);
        setError("");
        // setDialogTitle("OTP Resent");
        setDialogMessage("OTP has been resent.");
        setDialogOpen(true);
        setResendOtpProgress(100);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP.");
      setResendOtpProgress(0);
    } finally {
      setIsResendingOtp(false);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, Introduction_video: file }));
    }
  };

  const handleChange = (fieldName, value) => {
    let errorMsg = "";
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }));
    if (fieldName === "Relevant_Experience" && value.trim() !== "") {
      if (!/^\d*\.?\d?$/.test(value)) {
        errorMsg = "Relevant experience must be a number with at most one decimal place";
      } else {
        const relevantExp = parseFloat(value);
        if (relevantExp >= 25) {
          errorMsg = "Relevant experience must be less than 25 years";
        }
      }
    }
    setError((prevState) => ({
      ...prevState,
      [fieldName]: "",
    }));
  };

  const labelMap = {
    Describe_yourself: "Describe Yourself",
    Five_year_goal: "Yourself after 5 years",
    Preferred_Location: "Preferred Location",
    current_ctc: "Current CTC (Yearly)",
    Total_Experience: "Total Experience",
  };

  const validateForm = (fieldsToValidate = requiredFields) => {
    const newErrors = {};
    const relevantValue = formData?.Relevant_Experience;
  
    // Validation for Relevant Experience
    if (relevantValue && relevantValue.trim() !== "") {
      if (!/^\d+(\.\d)?$/.test(relevantValue)) {
        newErrors["Relevant_Experience"] =
          "Relevant experience must be a number with at most one decimal place";
      } else {
        const relevantExp = parseFloat(relevantValue);
        if (relevantExp >= 25) {
          newErrors["Relevant_Experience"] =
            "Relevant experience must be less than 25 years";
        }
      }
    }
  
    const joiningDays = formData?.Earliest_Joining_days;
    if (joiningDays && joiningDays.trim() !== "") {
      const days = Number(joiningDays);
      if (!/^\d+$/.test(joiningDays)) {
        newErrors.Earliest_Joining_days = "Please enter a valid number of days";
      } else if (days <= 0) {
        newErrors.Earliest_Joining_days = "Please enter a valid number of days";
      } else if (days > 120) {
        newErrors.Earliest_Joining_days = "Joining days cannot exceed 120 days";
      }
    }
    const takeHome = formData?.Current_Take_Home_Monthly;
      if (takeHome && takeHome.toString().trim() !== "") {
        const value = Number(takeHome);
        if (!/^\d+(\.\d+)?$/.test(takeHome)) {
          newErrors.Current_Take_Home_Monthly = "Please enter a valid number";
        } else if (value <= 0) {
          newErrors.Current_Take_Home_Monthly = "Value must be greater than 0";
        }
      }
  
    fieldsToValidate.forEach((field) => {
      const value = formData?.[field];
      const prefilledValue = jobData?.[field]; // Check if the field is prefilled from jobData
  
      // Skip required check if the field is prefilled from jobData
      if (
        requiredFields.includes(field) &&
        !prefilledValue && // Only check if not prefilled
        (value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === ""))
      ) {
        newErrors[field] = `${labelMap[field] || field} is required`;
        return;
      }
      if (value) {
        if (field === "current_ctc") {
          if (!/^\d+(\.\d+)?$/.test(value)) {
            newErrors[field] = "Current CTC must be a number";
          } else {
            const ctc = parseFloat(value);
            if (ctc < 100000 || ctc > 1500000) {
              newErrors[field] = "Please enter current CTC in lakhs";
            }
          }
        }
        if (field === "Total_Experience") {
          if (!/^\d+(\.\d)?$/.test(value)) {
            newErrors[field] =
              "Total experience must be a valid number with at most one decimal place";
          } else {
            const exp = parseFloat(value);
            if (exp > 25) {
              newErrors[field] = "Total experience should not exceed 25 years";
            }
          }
        }
        if (
          field === "Five_year_goal" &&
          !/(?=.*[A-Za-z]).*[^\d\s]/.test(value)
        ) {
          newErrors[field] =
            "Five year goal must include letters and not be only numbers or special characters";
        }
        if (
          field === "Describe_yourself" &&
          !/(?=.*[A-Za-z]).*[^\d\s]/.test(value)
        ) {
          newErrors[field] =
            "Description must include letters and not be only numbers or special characters";
        }
      }
    });
  
    // Special validation for expected_ctc (optional)
    const expectedCtcValue = formData?.expected_ctc;
    if (expectedCtcValue) {
      if (!/^\d+(\.\d+)?$/.test(expectedCtcValue)) {
        newErrors.expected_ctc = "Expected CTC must be a number";
      } else {
        const expectedCTC = parseFloat(expectedCtcValue);
        if (expectedCTC < 100000 || expectedCTC > 2400000) {
          newErrors.expected_ctc = "Expected CTC not valid";
        }
      }
    }
  
    return newErrors;
  };

  const handleSubmit = async () => {
    // Validate form first before showing any dialog
    const errors = validateForm(requiredFields);
    
    if (!otpVerified) {
      setError({ general: "Please verify OTP before submitting the form." });
      return;
    }
  
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return; // Stop here - don't show dialog for validation errors
    }
  
    // Only show dialog if validation passes
    setIsSubmitting(true);
    setDialogOpen(true);
    setProgressDialogStage("submitting");
    setDialogProgress(0);
    setShowIcon(false);
    setDialogTitle("Submitting");
    setDialogMessage("Submitting your application...");
  
    try {
      const formPayload = new FormData();
      formPayload.append("id", id);
      formPayload.append(
        "Do_you_want_to_work_with_a_small_org",
        formData.Do_you_want_to_work_with_a_small_org || ""
      );
      formPayload.append("Describe_yourself", formData.Describe_yourself || "");
      formPayload.append(
        "Roles_and_responsibilities",
        formData.Roles_and_responsibilities || ""
      );
      formPayload.append("Why_apply", formData.Why_apply || "");
      formPayload.append("Five_year_goal", formData.Five_year_goal || "");
      formPayload.append(
        "Preferred_Location",
        formData.Preferred_Location || ""
      );
      formPayload.append("current_ctc", formData.current_ctc || "");
      formPayload.append(
        "Current_Take_Home_Monthly",
        formData.Current_Take_Home_Monthly || ""
      );
      formPayload.append("expected_ctc", formData.expected_ctc || "");
      formPayload.append(
        "Expected_CTC_Negotiable",
        formData.Expected_CTC_Negotiable || ""
      );
      formPayload.append("Total_Experience", formData.Total_Experience || "");
      formPayload.append(
        "Relevant_Experience",
        formData.Relevant_Experience || ""
      );
      formPayload.append(
        "Earliest_Joining_days",
        formData.Earliest_Joining_days || ""
      );
      formPayload.append(
        "Holding_other_offer",
        formData.Holding_other_offer || ""
      );
  
      if (formData.Introduction_video) {
        formPayload.append("Introduction_video", formData.Introduction_video);
      }
  
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/shortlisted-form`,
        {
          method: "POST",
          body: formPayload,
        }
      );
  
      const result = await response.json().catch(() => response.text());
  
      if (response.ok) {
        setProgressDialogStage("success");
        setDialogTitle("Form Submitted Successfully"); // Changed from "Oh Yeah!"
        setDialogMessage("Thank you! Your shortlist form has  been submitted successfully.");
        setIsFormAlreadySubmitted(true);
        setSubmitted(true);
      } else {
        setProgressDialogStage("error");
        setDialogTitle("Something Went Wrong");
        setDialogMessage(
          "We couldn’t submit your shortlist form. Please refresh the page or try later."
        );
        setError({ general: result.error || "Submission failed" });
      }
    } catch (error) {
      console.error("Submission error:", error);
      setProgressDialogStage("error");
      setDialogTitle("Something Went Wrong");
      setDialogMessage("We couldn’t submit your shortlist form. Please refresh the page or try later.");
      setError({ general: "Network or server error" });
    } finally {
      setIsSubmitting(false); // Reset submitting state
    }
  };
  const handleNext = () => {
    const fieldsToValidate = fieldsPerStep[activeStep] || [];

    // validate current tab fields
    const currentErrors = validateForm(fieldsToValidate);

    if (Object.keys(currentErrors).length > 0) {
      setError(currentErrors);
      return; // don't go to next tab if errors
    }

    // no errors: clear error and move to next or submit
    setError({});
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    } else {
      handleSubmit();
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const isEditableValue = (value) => {
    return value === null || value === undefined || value === "" || value === "null";
  };
  const inputPropsStyle = {
    sx: {
      width: "100%", // Add this
      borderRadius: "15px",
      backgroundColor: "transparent",
      color: "rgb(46, 43, 43)",

      "& .MuiOutlinedInput-root": {
        width: "100%", // Add this
        borderRadius: "15px",
        fontSize: "18px",
        fontFamily: "Lexend",
        color: "rgb(46, 43, 43)",
        px: { xs: 1.5, sm: 2 },
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa",
        borderRadius: "15px",
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#3DA3C4 !important",
        borderWidth: "2px",
      },

      "& input": {
        width: "100%", // Add this to control input box
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& textarea": {
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& .MuiFormHelperText-root": {
        fontSize: "16px",
        fontFamily: "Lexend",
      },
    },
  };

  const inputLabelPropsStyle = {
    shrink: true,
    sx: {
      color: "#000",
      fontSize: "16px",
      fontweight: "500",
      fontFamily: "Lexend",
      marginBottom: "5px",
      "&.Mui-focused": {
        color: "#000",
      },
    },
  };

  const labelStyle = {
    fontFamily: "Lexend",
    lineHeight: "1.4375em",
    position: "relative",
    transformOrigin: "left top",
    fontWeight: 500,
    fontSize: { xs: "16px", sm: "18px" }, // responsive font size
    color: "rgb(10, 10, 10)",
    marginBottom: "6px",
    display: "block",
    padding: 0,
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    transition:
      "color 200ms cubic-bezier(0, 0, 0.2, 1), transform 200ms cubic-bezier(0, 0, 0.2, 1), max-width 200ms cubic-bezier(0, 0, 0.2, 1)",
  };

  const commonButtonStyle = {
    borderRadius: "50px",
    border: "2px solid #0087B4",
    color: "#0087B4",
    padding: "14px 28px", // More padding
    fontSize: "20px", // Larger text
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    textTransform: "none",
    backgroundColor: "#FFFFFFD9",
    fontFamily: "Lexend",
    minWidth: "180px", // Wider button
    height: "55px", // Taller button
    "&:hover": {
      backgroundColor: "#0087B4",
      color: "#FFFFFFD9",
    },
  };

  if (showOtpScreen) {
    return (
      <Box
        sx={{
          mt: { xs: 8, md: 8 },
          display: "flex",
          flexDirection: "row",
          "@media (max-width: 1105px)": {
            flexDirection: "column",
          },
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 4, md: 6, lg: 12 },
          py: { xs: 4, md: 8 },
          gap: { xs: 4, md: 6 },
          width: "100%",
          maxWidth: "100vw",
          minHeight: "87vh",
          boxSizing: "border-box",
          overflow: "hidden",
          textAlign: "left",
          "@media (max-width:1105px)": {
            flexDirection: "column",
            alignItems: "center",
          },
        }}
      >
        {(isSendingOtp || isVerifyingOtp || isResendingOtp) && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1300,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "white",
                padding: 4,
                borderRadius: 2,
              }}
            >
              <CircularProgress
                variant="determinate"
                value={
                  isSendingOtp
                    ? sendOtpProgress
                    : isVerifyingOtp
                      ? verifyOtpProgress
                      : resendOtpProgress
                }
                size={60}
                thickness={4}
                sx={{ color: "#0087B4" }}
              />
              <Typography sx={{ mt: 2, color: "#333", fontFamily: "Lexend", fontSize: "18px" }}>
                {isSendingOtp
                  ? "Sending OTP..."
                  : isVerifyingOtp
                    ? "Verifying OTP..."
                    : "Resending OTP..."}
              </Typography>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            order: 1,
            width: { xs: "100%", md: "45%", lg: "40%" },
            maxWidth: { xs: "700px", md: "600px" },
            mb: { xs: 4, md: 0 },
            textAlign: "center",
            flexShrink: 0,
            "& img": {
              width: "100%",
              height: "auto",
              maxWidth: { xs: "700px", md: "100%" },
              objectFit: "contain",
            },
            "@media (max-width: 1105px)": {
              order: -1,
              width: "100%",
              maxWidth: "700px",
              mb: 4,
            },
          }}
        >
          <img
            src={otpImage}
            alt="OTP Illustration"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
              borderRadius: "15px",
            }}
          />
        </Box>

        {/* Content Section */}
        <Box
          sx={{
            order: 0,
            width: { xs: "100%", md: "55%", lg: "50%" },
            maxWidth: "600px",
            px: { xs: 1, sm: 2 },
            textAlign: "left",
            transform: {
              xs: "translateX(0)",
              sm: "translateX(-1%)",
              md: "translateX(-2%)",
              lg: "translateX(-4%)",
              xl: "translateX(0%)",
            },
            transition: "transform 0.3s ease",
            "@media (max-width:1105px)": {
              order: 0,
              width: "100%",
              maxWidth: "700px",
            },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "36px", sm: "38px", md: "40px", lg: "40px" },
              fontWeight: "500",
              mb: 2,
              textAlign: "left",
              fontFamily: "Lexend",
              color: "#000000DE",
            }}
          >
            Welcome, {jobData?.name} - Complete OTP Verification to proceed
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {!isOtpSent ? (
            <>
              <Typography
                sx={{
                  fontSize: "16px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#555555",
                }}
              >
                Click "Send OTP" to receive a verification code on your email.
              </Typography>
              <Button
                variant="contained"
                onClick={handleSendOtp}
                sx={{
                  mt: 2,
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none",
                  },
                }}
              >
                Send OTP
              </Button>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "18px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#000000DE",
                }}
              >
                Please enter the 6-digit OTP sent to your email
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    name={`otp-${index}`}
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "18px",
                        padding: 0,
                        fontFamily: "Lexend",
                        color: "#000000DE",
                      },
                    }}
                    sx={{
                      width: "61px",
                      height: "50px",
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                      borderRadius: "15px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "15px",
                        height: "100%",
                      },
                    }}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                onClick={handleVerifyOtp}
                sx={{
                  mb: 2,
                  width: "170px",
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none",
                  },
                }}
              >
                Verify OTP
              </Button>

              <Box>
                <Button
                  onClick={handleResendOtp}
                  sx={{
                    mt: 1,
                    color: "#0087B4",
                    padding: 0,
                    pl: 3,
                    fontSize: "18px",
                    fontWeight: 380,
                    textTransform: "none",
                    backgroundColor: "transparent",
                    minWidth: "auto",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                    },
                    "&:focus": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  Resend OTP
                </Button>
              </Box>

              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                PaperProps={{
                  sx: {
                    width: 450,
                    maxWidth: "90vw",
                    padding: 2,
                    fontSize: "18px",
                    fontFamily: "Lexend",
                    color: "#000000DE",
                    borderRadius: "19px",
                  },
                }}
              >
                <DialogTitle sx={{ fontFamily: "Lexend", fontWeight:400}}>{dialogTitle}</DialogTitle>
                <DialogContent>
                  <Typography sx={{ fontFamily: "Lexend", fontWeight:300, color:'#000000DE'}}>{dialogMessage}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setDialogOpen(false)} sx={{ fontFamily: "Lexend", color:'#0087B4'}}>Ok</Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        </Box>
      </Box>
    );
  }


  return (
    <Box
      sx={{
        width: "100%",
        mt: { xs: "80px", md: "120px" },
        boxSizing: "border-box",
        overflowX: "hidden",
      }}
    >
      {/* <Box
        sx={{
          width: "70vw",
          mx: "auto",
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: { xs: "column", sm: "row" }, 
          gap: 3,
          minWidth: 300,
        }}
      >
        <Box
          component="img"
          src={logoImage}
          alt="Logo"
          sx={{
            height: { xs: 20, sm: 25, md: 30 }, 
            maxWidth: "100%",
            objectFit: "contain",
            mb: { xs: 1, sm: 0 },
          }}
        />
        <Typography variant="body2" sx={{ fontSize: { xs: 12, md: 14 } }}>
          Login as {jobData?.email}
        </Typography>
      </Box> */}

      {/* <Divider sx={{ width: "100%" }} /> */}

      <Box
        sx={{
          width: "100%",
          maxWidth: "1480px",
          mx: "auto",
          boxSizing: "border-box",
          paddingLeft: { xs: "12px", sm: "24px", md: "32px" },
          paddingRight: { xs: "12px", sm: "24px", md: "32px" },
          "@media (min-width:900px)": {
            paddingLeft: "125px",
            paddingRight: "85px",
          },
        }}
      >
        <Grid
          container
          spacing={2}
          direction={isSmallScreen ? "column" : "row"}
          alignItems={isSmallScreen ? "center" : "flex-start"}
        >
          {/* Stepper */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              pt: 5.75,
              mb: isSmallScreen ? 3 : 0,
              mt: isSmallScreen ? 2 : 0,
              pl: isSmallScreen ? 1 : 0,
              display: isVerySmallScreen ? "flex" : "block",
              justifyContent: isVerySmallScreen ? "center" : "flex-start",
              "@media (max-width:900px)": {
                mt: "36px",
              },
            }}
          >
            <Stepper
              activeStep={activeStep}
              orientation={isSmallScreen ? "horizontal" : "vertical"}
              alternativeLabel={isSmallScreen}
              sx={{
                width: "100%",
                justifyContent: isSmallScreen ? "center" : "flex-start",
                "& .MuiStepIcon-root": {
                  color: "#0087B4",
                  fontSize: "1.95rem",
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "#0087B4",
                  fontSize: "1.95rem",
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "#0087B4",
                  fontSize: "1.95rem",
                },
                "& .MuiStepConnector-line": {
                  borderColor: "#00002D",
                },
              }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontSize: "18px",
                        fontFamily: "Lexend",
                        color: "#000000DE",
                        textAlign: isSmallScreen ? "center" : "inherit",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid item xs={12} md={9} sx={{ borderRadius: "15px", pt: 8,mt: isSmallScreen ? 2 : 1.5, }}>
            {activeStep === 0 && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "28px",
                    fontFamily: "Lexend",
                    color: "#000000DE",
                  }}
                >
                  About Your Profile
                </Typography>
                {isFormAlreadySubmitted && (
                  <Alert
                    severity="success"
                    sx={{
                      mt: 4,
                      mb: 4,
                      backgroundColor: colors.primary,
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                    }}
                  >

                    Form has already been submitted.
                  </Alert>
                )}
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Name</Typography>
                    <TextField
  fullWidth
  value={
    [
      jobData?.name,
      jobData?.Middle_Name,
      jobData?.Last_Name
    ]
    .map(part => (part && part !== "null") ? part : "") // Filters out null and "null" strings
    .filter(Boolean) // Removes empty strings
    .join(" ")
  }
  disabled
  InputProps={{
    readOnly: true,
    sx: {
      input: {
        paddingLeft: "0.2px",
        color: "#000",
      },
    },
  }}
  sx={inputPropsStyle.sx}
/>
                  </Grid>

                  {/* Job Title */}
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Job Title</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.job_title || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px",
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Email</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.email || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px",
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>

                  {/* Mobile Number */}
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Mobile No.</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.mobile_no || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px",
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography sx={labelStyle}>
                      Do you want to work with a small org?
                    </Typography>

                    <TextField
                      select
                      fullWidth
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Do_you_want_to_work_with_a_small_org || ""}
                      onChange={(e) =>
                        handleChange("Do_you_want_to_work_with_a_small_org", e.target.value)
                      }
                      InputProps={{
                        ...inputPropsStyle,
                        sx: {
                          ...inputPropsStyle?.sx,
                          fontFamily: "Lexend",
                          color:
                            !formData?.Do_you_want_to_work_with_a_small_org || formData?.Do_you_want_to_work_with_a_small_org === ""
                              ? "#9e9e9e"
                              : "inherit", // Placeholder color when no selection
                        },
                      }}
                      SelectProps={{
                        displayEmpty: true,
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              backgroundColor: "white",
                              borderRadius: "15px",
                              color: "#000000DE",
                              fontFamily: "Lexend",
                              "& .MuiMenuItem-root": {
                                "&.Mui-selected": {
                                  backgroundColor: "#3DA3C4",
                                  fontFamily: "Lexend",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      <MenuItem value="" disabled sx={{ fontFamily: "Lexend", }}>
                        Select an option
                      </MenuItem>
                      <MenuItem value="Yes" sx={{ fontFamily: "Lexend", }}>Yes</MenuItem>
                      <MenuItem value="No" sx={{ fontFamily: "Lexend", }}>No</MenuItem>
                    </TextField>

                  </Grid>
                  <Grid item xs={12}>
                    {/* Label above video file input */}
                    <Typography sx={labelStyle}>
                      Upload a small introduction video to describe yourself
                    </Typography>

                    <TextField
                      fullWidth
                      type="file"
                      disabled={isFormAlreadySubmitted}
                      placeholder="Choose a video file"
                      helperText="Only .mp4 and .webm formats are accepted"
                      InputLabelProps={{
                        shrink: true,
                        ...inputLabelPropsStyle,
                      }}
                      inputProps={{
                        accept: "video/mp4, video/webm",  // ✅ Updated here
                      }}
                      InputProps={{
                        ...inputPropsStyle,
                        endAdornment: formData?.Introduction_video ? (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setOpenVideoModal(true)}
                              edge="end"
                              aria-label="Preview video"
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                      onChange={handleVideoChange}
                    />

                    {formData?.Introduction_video?.name && (
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {formData?.Introduction_video.name}
                      </Typography>
                    )}

                    <Dialog
                      open={openVideoModal}
                      onClose={() => setOpenVideoModal(false)}
                      maxWidth="md"
                      fullWidth
                      PaperProps={{
                        sx: {
                          borderRadius: "15px",
                        },
                      }}
                    >
                      <DialogTitle>
                        Video Preview
                        <IconButton
                          onClick={() => setOpenVideoModal(false)}
                          sx={{ position: "absolute", right: 8, top: 8 }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        {formData?.Introduction_video && (
                          <video
                            controls
                            style={{ width: "100%" }}
                            src={
                              typeof formData.Introduction_video === "string"
                                ? formData.Introduction_video
                                : formData.Introduction_video instanceof File
                                  ? URL.createObjectURL(
                                    formData.Introduction_video
                                  )
                                  : ""
                            }
                          />
                        )}
                      </DialogContent>
                    </Dialog>
                  </Grid>

                  <Grid item xs={12}>
                    {/* Label above textarea */}
                    <Typography sx={labelStyle}>
                      Describe yourself in a few words{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>

                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Describe_yourself || ""}
                      onChange={(e) =>
                        handleChange("Describe_yourself", e.target.value)
                      }
                      placeholder="Write a short description about yourself"
                      InputProps={inputPropsStyle}
                      InputLabelProps={inputLabelPropsStyle}
                      error={!!error?.Describe_yourself}
                      helperText={error?.Describe_yourself}
                    />
                  </Grid>
                </Grid>
              </>
            )}

            {activeStep === 1 && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "28px",
                    fontFamily: "Lexend",
                  }}
                >
                  Profile & Preferences
                </Typography>

                {isFormAlreadySubmitted && (
                  <Alert
                    severity="success"
                    sx={{
                      mt: 4,
                      mb: 4,
                      backgroundColor: colors.primary,
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "rgba(0, 0, 0, 0.87)",
                    }}
                  >
                    Form has already been submitted.
                  </Alert>
                )}

                <Grid container spacing={2} sx={{ mt: 2 }}>
                  {/* Roles & Responsibilities */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Describe your roles and responsibilities in your current
                      project
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      placeholder="Enter your roles and responsibilities"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Roles_and_responsibilities || ""}
                      onChange={(e) =>
                        handleChange(
                          "Roles_and_responsibilities",
                          e.target.value
                        )
                      }
                      InputProps={inputPropsStyle}
                    />
                  </Grid>

                  {/* Why Apply */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Why do you think you should apply for this position?
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      placeholder="Enter your reason"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Why_apply || ""}
                      onChange={(e) =>
                        handleChange("Why_apply", e.target.value)
                      }
                      InputProps={inputPropsStyle}
                    />
                  </Grid>

                  {/* 5 Year Goal */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Where do you see yourself after 5 years?{" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      placeholder="Describe your 5 year goal"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Five_year_goal || ""}
                      onChange={(e) =>
                        handleChange("Five_year_goal", e.target.value)
                      }
                      InputProps={inputPropsStyle}
                      error={!!error?.Five_year_goal}
                      helperText={error?.Five_year_goal}
                    />
                  </Grid>

                  {/* Preferred Location */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Preferred Location <span style={{ color: "red" }}>*</span>
                    </Typography>

                    <TextField
                      select
                      fullWidth
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Preferred_Location || ""}
                      onChange={(e) => handleChange("Preferred_Location", e.target.value)}
                      InputProps={{
                        ...inputPropsStyle,
                        sx: {
                          ...inputPropsStyle?.sx,
                          fontFamily: "Lexend",
                          color:
                            !formData?.Preferred_Location || formData?.Preferred_Location === ""
                              ? "#9e9e9e"
                              : "inherit", // grey for placeholder, black for selected
                        },
                      }}
                      error={!!error?.Preferred_Location}
                      helperText={error?.Preferred_Location}
                      SelectProps={{
                        displayEmpty: true,
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              backgroundColor: "white",
                              borderRadius: "15px",
                              color: "#000000DE",
                              fontFamily: "Lexend",
                              "& .MuiMenuItem-root": {
                                "&.Mui-selected": {
                                  backgroundColor: "#3DA3C4",
                                  fontFamily: "Lexend",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {/* Placeholder */}
                      <MenuItem value="" disabled sx={{ fontFamily: "Lexend", color: "#212121" }}>
                        Select preferred location
                      </MenuItem>

                      {/* Actual options */}
                      <MenuItem value="Pune" sx={{ fontFamily: "Lexend", }}>Pune</MenuItem>
                      <MenuItem value="Ahmedabad" sx={{ fontFamily: "Lexend", }}>Ahmedabad</MenuItem>
                      <MenuItem value="Any" sx={{ fontFamily: "Lexend", }}>Any</MenuItem>
                    </TextField>
                  </Grid>


                  {/* Current CTC */}
                  <Grid item xs={12}>
    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
      Current CTC (Yearly){" "}
      <span style={{ color: "red" }}>*</span>
    </Typography>
    <TextField
      fullWidth
      type="number"
      placeholder="Enter current CTC"
      disabled={isFormAlreadySubmitted ||  !isEditableValue(jobData?.current_ctc)}
      value={formData?.current_ctc || jobData?.current_ctc || ""}
      onChange={(e) =>
        handleChange("current_ctc", e.target.value)
      }
      InputProps={inputPropsStyle}
      inputProps={{
        inputMode: 'numeric',
        style: {
          appearance: 'textfield',
          MozAppearance: 'textfield',
        },
      }}
      sx={{
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      }}
      error={!!error?.current_ctc}
      helperText={error?.current_ctc}
    />
  </Grid>

                  {/* Current Take Home */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Current Take Home (Monthly)
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="Enter monthly take home"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Current_Take_Home_Monthly || ""}
                      onChange={(e) =>
                        handleChange(
                          "Current_Take_Home_Monthly",
                          e.target.value
                        )
                      }
                      InputProps={inputPropsStyle}
                      inputProps={{
                        inputMode: 'numeric',
                        style: {
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                        },
                      }}
                      sx={{
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                      error={!!error?.Current_Take_Home_Monthly}
                      helperText={error?.Current_Take_Home_Monthly}
                    />
                  </Grid>

                  {/* Expected CTC */}
                  <Grid item xs={12}>
    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
      Expected CTC (Yearly)
    </Typography>
    <TextField
      fullWidth
      type="number"
      placeholder="Enter expected CTC"
      disabled={isFormAlreadySubmitted || !isEditableValue(jobData?.expected_ctc)}
      value={formData?.expected_ctc || jobData?.expected_ctc || ""}
      onChange={(e) =>
        handleChange("expected_ctc", e.target.value)
      }
      InputProps={inputPropsStyle}
      inputProps={{
        inputMode: 'numeric',
        style: {
          appearance: 'textfield',
          MozAppearance: 'textfield',
        },
      }}
      sx={{
        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
          WebkitAppearance: 'none',
          margin: 0,
        },
      }}
      error={!!error?.expected_ctc}
      helperText={error?.expected_ctc}
    />
  </Grid>
                  {/* Expected CTC Negotiable */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Expected CTC Negotiable
                    </Typography>

                    <TextField
                      fullWidth
                      select
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Expected_CTC_Negotiable || ""}
                      onChange={(e) =>
                        handleChange("Expected_CTC_Negotiable", e.target.value)
                      }
                      InputProps={{
                        ...inputPropsStyle,
                        sx: {
                          ...inputPropsStyle?.sx,
                          fontFamily: "Lexend",
                          color:
                            !formData?.Expected_CTC_Negotiable ||
                              formData?.Expected_CTC_Negotiable === ""
                              ? "#9e9e9e"
                              : "inherit", // Light grey for placeholder
                        },
                      }}
                      SelectProps={{
                        displayEmpty: true,
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              backgroundColor: "white",
                              borderRadius: "15px",
                              color: "#000000DE",
                              "& .MuiMenuItem-root": {
                                "&.Mui-selected": {
                                  backgroundColor: "#3DA3C4",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {/* Placeholder Option */}
                      <MenuItem value="" disabled sx={{ fontFamily: "Lexend", color: "#212121" }}>
                        Select CTC Negotiable
                      </MenuItem>

                      {/* Real Options */}
                      <MenuItem value="Yes" sx={{ fontFamily: "Lexend", }}>Yes</MenuItem>
                      <MenuItem value="No" sx={{ fontFamily: "Lexend", }}>No</MenuItem>
                    </TextField>
                  </Grid>


                  {/* Total Experience */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Total Experience (Yearly){" "}
                      <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="Enter total experience"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Total_Experience || ""}
                      onChange={(e) =>
                        handleChange("Total_Experience", e.target.value)
                      }
                      InputProps={inputPropsStyle}
                      inputProps={{
                        inputMode: 'numeric',
                        style: {
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                        },
                      }}
                      sx={{
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                      error={!!error?.Total_Experience}
                      helperText={error?.Total_Experience}
                    />
                  </Grid>

                  {/* Relevant Experience */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Relevant Experience (For Key Skills)
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="Enter relevant experience"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Relevant_Experience || ""}
                      onChange={(e) =>
                        handleChange("Relevant_Experience", e.target.value)
                      }
                      InputProps={inputPropsStyle}
                      inputProps={{
                        inputMode: 'numeric',
                        style: {
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                        },
                      }}
                      sx={{
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                      error={!!error?.Relevant_Experience}
                      helperText={error?.Relevant_Experience}
                    />

                  </Grid>

                  {/* Earliest Joining */}
                  <Grid item xs={12}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Earliest Joining (in days)
                    </Typography>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="Enter earliest joining days"
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Earliest_Joining_days || ""}
                      onChange={(e) =>
                        handleChange("Earliest_Joining_days", e.target.value)
                      }
                      InputProps={inputPropsStyle}
                      inputProps={{
                        inputMode: 'numeric',
                        style: {
                          appearance: 'textfield',
                          MozAppearance: 'textfield',
                        },
                      }}
                      sx={{
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                          WebkitAppearance: 'none',
                          margin: 0,
                        },
                      }}
                      error={!!error?.Earliest_Joining_days}
                      helperText={error?.Earliest_Joining_days}
                    />
                  </Grid>

                  {/* Holding Other Offer */}
                  <Grid item xs={12} sx={{ mb: 4 }}>
                    <Typography sx={{ ...labelStyle, fontFamily: "Lexend" }}>
                      Holding any other offer currently?
                    </Typography>
                    <TextField
                      fullWidth
                      select
                      disabled={isFormAlreadySubmitted}
                      value={formData?.Holding_other_offer || ""}
                      onChange={(e) =>
                        handleChange("Holding_other_offer", e.target.value)
                      }
                      InputProps={{
                        ...inputPropsStyle,
                        sx: {
                          ...inputPropsStyle?.sx,
                          fontFamily: "Lexend",
                          color:
                            !formData?.Holding_other_offer || formData?.Holding_other_offer === ""
                              ? "#9e9e9e" // grey for placeholder
                              : "inherit", // default for selected
                        },
                      }}
                      SelectProps={{
                        displayEmpty: true,
                        MenuProps: {
                          PaperProps: {
                            sx: {
                              backgroundColor: "white",
                              borderRadius: "15px",
                              color: "#000000DE",
                              "& .MuiMenuItem-root": {
                                color: "#212121", // dark text for dropdown items
                                "&.Mui-selected": {
                                  backgroundColor: "#3DA3C4",
                                },
                              },
                            },
                          },
                        },
                      }}
                    >
                      {/* Placeholder */}
                      <MenuItem value="" disabled sx={{ fontFamily: "Lexend", color: "#212121" }}>
                        Select option
                      </MenuItem>

                      {/* Actual options */}
                      <MenuItem value="Yes" sx={{ fontFamily: "Lexend", }}>Yes</MenuItem>
                      <MenuItem value="No" sx={{ fontFamily: "Lexend", }}>No</MenuItem>
                    </TextField>
                  </Grid>

                </Grid>
              </>
            )}

            <Box
              sx={{
                mt: 4,
                pb: 4,
                display: "flex",
                justifyContent: "flex-end",
                gap: 3,
                borderRadius: "15px",
                flexWrap: "wrap",
              }}
            >
              {activeStep > 0 && (
                <Button
                  onClick={handleBack}
                  variant="outlined"
                  sx={commonButtonStyle}
                  startIcon={<ArrowBackIcon />}
                >
                  Back
                </Button>
              )}

              {activeStep === steps.length - 1 ? (
                !isFormAlreadySubmitted && (
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    sx={commonButtonStyle}

                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                )
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  sx={commonButtonStyle}
                  endIcon={<ArrowForwardIcon />}
                >
                  Continue
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Dialog
  open={dialogOpen}
  onClose={progressDialogStage !== "submitting" ? () => setDialogOpen(false) : undefined}
  disableEscapeKeyDown={progressDialogStage === "submitting"}
  PaperProps={{
    sx: {
      width: 450,
      maxWidth: "90vw",
      padding: 2,
      fontSize: "18px",
      fontFamily: "Lexend",
      color: "#000000DE",
      borderRadius: "19px",
    },
  }}
>
  <DialogContent>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 3,
        mt: 2,
        position: "relative",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={dialogProgress}
        size={80}
        thickness={2}
        sx={{
          color: progressDialogStage === "error" ? "#f44336" : "#0087B4",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 80,
          opacity: showIcon ? 1 : 0,
          transform: showIcon ? "scale(1)" : "scale(0)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {progressDialogStage === "success" && (
          <CheckIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#0087B4",
            }}
          />
        )}
        {progressDialogStage === "error" && (
          <PriorityHighIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#f44336",
            }}
          />
        )}
      </Box>
    </Box>

    {progressDialogStage === "submitting" && (
      <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontSize: "18px", fontWeight: 400 }}>
        Submitting Application...
      </Typography>
    )}

    {(progressDialogStage === "success" || progressDialogStage === "error") && (
      <>
        <DialogTitle sx={{ textAlign: "center", fontFamily: "Lexend", fontSize: "20px", fontWeight: "bold", pb: 1 }}>
          {dialogTitle}
        </DialogTitle>
        <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontWeight:300, fontSize: "16px" }}>
          {dialogMessage}
        </Typography>
      </>
    )}
  </DialogContent>

  {progressDialogStage !== "submitting" && (
    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
      <Button
        onClick={() => {
          setDialogOpen(false);
          if (progressDialogStage === "success" && website) {
            window.location.href = website;
          }
        }}
        variant="contained"
        sx={{
          backgroundColor: "#0087B4",
          "&:hover": {
            backgroundColor: "#006e96",
          },
          borderRadius: "8px",
          px: 4,
          py: 1,
          fontSize: "16px",
          fontFamily: "Lexend",
        }}
      >
        OK
      </Button>
    </DialogActions>
  )}
</Dialog>
    </Box>
  );
};

export default ShortlistForm;